<ion-header>
  <ion-toolbar class="modal-header">
    <ion-title>
      Şifre Değiştir
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" style="font-size: 18px;">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div id="form-container">
<dx-form
  [formData]="passwordForm.value"
  [colCount]="1"
  [showColonAfterLabel]="true"
  (onFieldDataChanged)="onFieldChanged($event)"
>

    <!-- Şifre Bilgileri -->
    <dxi-item itemType="group" captionTemplate="passwords">
      <dxi-item dataField="currentPassword" [label]="{ text: '*Eski Şifre' }" editorType="dxTextBox"
        [editorOptions]="{ mode: 'password' }">
        <dxi-validation-rule type="required" message="Eski şifre zorunludur."></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="newPassword" [label]="{ text: '*Yeni Şifre' }" editorType="dxTextBox"
        [editorOptions]="{ mode: 'password' }">
        <dxi-validation-rule type="required" message="Yeni şifre zorunludur."></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="confirmNewPassword" [label]="{ text: '*Yeni Şifre Tekrar' }" editorType="dxTextBox"
        [editorOptions]="{ mode: 'password' }">
        <dxi-validation-rule type="required" message="Şifre tekrarı zorunludur."></dxi-validation-rule>
      </dxi-item>
    </dxi-item>

    <!-- Caption Template -->
    <div *dxTemplate="let data of 'passwords'" class="dx-form-group-custom-caption bordered-caption">
      <i class="dx-icon dx-icon-lock"></i>
      <span>Şifre Bilgileri</span>
    </div>
  </dx-form>
</div>

<ion-footer>
  <ion-toolbar class="modal-footer">
    <div class="modal-action-buttons">
      <ion-button expand="block" fill="solid" color="primary" (click)="submitPasswordChange()" >
        <ion-icon slot="start" name="key-outline"></ion-icon>
        Şifreyi Değiştir
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
